var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1654 19.3409C47.7597 16.4925 52.2413 16.4925 54.8356 19.3409L58.1715 23.0039C59.4824 24.4435 61.3668 25.224 63.312 25.1331L68.2609 24.9019C72.1092 24.722 75.2787 27.8912 75.0988 31.7397L74.8673 36.6887C74.7764 38.6337 75.5569 40.518 76.9966 41.829L80.6595 45.1649C83.5082 47.7592 83.5082 52.2408 80.6595 54.8351L76.9966 58.171C75.5569 59.4819 74.7764 61.3663 74.8673 63.3115L75.0988 68.2604C75.2787 72.1087 72.1092 75.2782 68.2609 75.0983L63.312 74.8668C61.3668 74.7759 59.4824 75.5564 58.1715 76.9962L54.8356 80.659C52.2413 83.5077 47.7597 83.5077 45.1654 80.659L41.8295 76.9962C40.5185 75.5564 38.6341 74.7759 36.6891 74.8668L31.7402 75.0983C27.8917 75.2782 24.7225 72.1087 24.9023 68.2604L25.1336 63.3115C25.2245 61.3663 24.444 59.4819 23.0044 58.171L19.3414 54.8351C16.493 52.2408 16.493 47.7592 19.3414 45.1649L23.0044 41.829C24.444 40.518 25.2245 38.6337 25.1336 36.6887L24.9023 31.7397C24.7225 27.8912 27.8917 24.722 31.7402 24.9019L36.6891 25.1331C38.6341 25.224 40.5185 24.4435 41.8295 23.0039L45.1654 19.3409Z",
    stroke: "#1884C7",
    strokeWidth: 4.90476
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1914 49.9996L46.7311 56.5393L59.8105 43.46",
    stroke: "#1884C7",
    strokeWidth: 4.90476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.920cf3bb2af3ad632e4edc81933dbe73.svg";
export { ForwardRef as ReactComponent };